// Autogenerated file
export const trackerTypesEnum = {
    Default: "Default",
    Autograf: "Autograf",
    Mobile: "Mobile",
    Wialon: "Wialon",
};
export const trackerTypes = [
    { label: "Обычный", value: "Default" },
    { label: "ЕГТС", value: "Autograf" },
    { label: "Мобильный", value: "Mobile" },
    { label: "Wialon", value: "Wialon" },
];
